import Stack, { type StackProps } from '@mui/material/Stack';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';

type Props = {
  children: React.ReactNode;
  /**
   * On phone (below the sm breakpoint), force every child to fill the row
   * equally. Useful for dialog footers where two buttons should split 50/50
   * on phone but keep their natural width on tablet and desktop. The
   * explicit `flex: '1 1 0'` + `minWidth: 0` overrides MUI Button's default
   * `min-width: 64px`, which would otherwise let a longer label keep more
   * space than a shorter one.
   */
  splitOnMobile?: boolean;
  /** Caller overrides — useful for shrinking the row to auto width when it
   * needs to coexist with other content (e.g. picker bay row on desktop). */
  sx?: StackProps['sx'];
};

export const ActionRow = ({ children, splitOnMobile = false, sx }: Props) => {
  const { isMobile } = useBreakpoint();
  return (
    <Stack
      sx={[
        {
          '& > *': {
            overflow: 'hidden',
            ...(splitOnMobile && isMobile
              ? {
                  flex: '1 1 0',
                  minWidth: 0,
                }
              : {}),
          },
          alignItems: 'center',
          flexDirection: 'row',
          gap: 1.5,
          justifyContent: isMobile ? 'space-between' : 'flex-end',
          width: '100%',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Stack>
  );
};
